import React from "react";
import ReactDOM from "react-dom";
import "react-perfect-scrollbar/dist/css/styles.css";
import "assets/css/utility.min.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
// import "antd/dist/antd.less";
import "antd/dist/reset.css";
import "assets/scss/dashboard.scss?v1.1.0";
import { APP_VERSION, TOKEN_NAME, REFRESH_TOKEN_NAME } from "./constants/index";
import { Provider } from "react-redux";
import configureAppStore from "./redux/store";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { AppRouter } from "./views/AppRouter";
// import SocketProvider from "./contexts/SocketContext";
import { SocketContext, socket } from "contexts/SocketContext";
import AppContextProvider from "contexts/AppContext";

// const stateLoader = new StateLoader()
// configureAppStore.subscribe(() => {
//   stateLoader.saveState(configureAppStore.getState())
// })

const appVersion = localStorage.getItem("APP-VERSION");
if (appVersion && appVersion !== APP_VERSION) {
  localStorage.clear();
  localStorage.setItem("APP-VERSION", APP_VERSION);
} else {
  localStorage.setItem("APP-VERSION", APP_VERSION);
}

const tokenLogger = (tokens) => {
  if (tokens && tokens.token && tokens.refreshToken) {
    localStorage.setItem(TOKEN_NAME, tokens.token);
    localStorage.setItem(REFRESH_TOKEN_NAME, tokens.refreshToken);
  }
};

ReactDOM.render(
  <>
    <Provider store={configureAppStore}>
      <SocketContext.Provider value={socket}>
        <AppContextProvider>
          <AppRouter />
        </AppContextProvider>
      </SocketContext.Provider>
    </Provider>
  </>,
  document.getElementById("root")
);

// function open() {
//   alert(
//     "New version is available and will be used when all tabs for this pageare closed."
//   );
// }

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
// serviceWorkerRegistration.register({ notification: () => open() });
